// Prevent right-click context menu on all images
document.addEventListener('contextmenu', function(e) {
	if (e.target.tagName === 'IMG' || e.target.tagName === 'PICTURE') {
		e.preventDefault();
		return false;
	}
});

// Prevent drag and drop on all images
document.addEventListener('dragstart', function(e) {
	if (e.target.tagName === 'IMG' || e.target.tagName === 'PICTURE') {
		e.preventDefault();
		return false;
	}
});
